export const ProfileSteps = [
  {
    step: 0,
    label: 'Select Product',
    active: true,
    completed: false,
    saved: false,
  },
  {
    step: 1,
    label: 'Merchant Details',
    active: false,
    completed: false,
    saved: false,
  },
  {
    step: 2,
    label: 'Company Auth Details',
    active: false,
    completed: false,
    saved: false,
  },
  {
    step: 3,
    label: 'Business Information',
    active: false,
    completed: false,
    saved: false,
  },
  {
    step: 4,
    label: 'Mandatory Details',
    active: false,
    completed: false,
    saved: false,
  },
  {
    step: 5,
    label: 'Bank Details',
    active: false,
    completed: false,
    saved: false,
  },
  {
    step: 6,
    label: 'Upload Documents',
    active: false,
    completed: false,
    saved: false,
  },
];
